<template>
  <div />
</template>

<script>
// import { getAgentInfo } from '@/api/user'

export default {
  name: 'Share',
  created() {
    let url = (window.location.href || document.location.href).replace('amp;', '')
    url = url.replace('amp%3B')
    const inviteCode = new URL(url).searchParams.get('code')
    console.log(inviteCode)
    if (inviteCode) {
      this.$store.commit('SET_INVITE_CODE', inviteCode)
    }

    if (this.$store.getters.token !== null) {
      // 已登入 導向會員首頁
      this.$router.push({ path: '/user' })
    } else {
      // 導向登入頁
      this.$router.push({ path: '/user/register' })
    }
  }
}
</script>
